const filters = [
    {
      id: 1,
      text: "Irin Pervin",
    },
    {
      id: 2,
      text: "Fatima Asrafy",
    },
    {
      id: 3,
      text: "Feres Ben Romdhan",
    },
    {
      id: 4,
      text: "Rama Hermi",
    },
    {
      id: 5,
      text: "Khoubayeb Layouni"
    }
];
export default filters;